import $ from 'jquery';
import {is_array, is_function} from '../../Helpers/js/simple.functions';
import UI from './0-ui';

// ----------- //
// DIALOG UI   //
// ----------- //
UI.Dialog = {
    isWaiting: false,
    isClosing: false,
    isOpen: false,
    doClose: true,
    allParams: new Array(),
    params: null,

    resizeTimer: false,
    resizeTrigger: 500, // call resize only every x ms

    open: function (params) {

        if (params.ajax == undefined) {
            return false;
        }

        // delete old for sure
        $('#' + params.name).remove(); // delete old for sure
        $('#' + params.ref).remove(); // delete old for sure

        UI.Dialog.params = params;
        UI.Dialog.allParams.push(params);

        var dialogParams = {
            id: params.ref,
            title: params.title,
            modal: false,
            stack: false,
            autoOpen: true,
            closeOnEscape: true,
            draggable: true,
            resizable: params.sizeable, // disable resize for IE, cause its buggy
            open: function () {
                UI.Dialog.onOpen();
            },
            close: function () {
                UI.Dialog.onClose();
            }, // wird nie aufgerufen
            resize: function () {
                UI.Dialog.onResize();
            },
            width: params.width,
            height: params.height,
            minWidth: 240,
            maxWidth: 1000,
            minHeight: params.minHeight || 120,
            maxHeight: params.maxHeight || 1000,
            dialogClass: params.dialogClass,
            closeText: 'x'
        };

        var dialog = $('<div id="' + params.name + '" class="' + params.cssClass + '"></div>');
        dialog.appendTo('body')
            .dialog(dialogParams).timedLoader(1);

        window.Browser.loadHTML(dialog, params.ajax, params.request, UI.Dialog.onLoad,
            function (json) {
                console.error(json);
                var msg = json && json.errors && is_array(json.errors) ? json.errors.join('<br>') : json.errors;
                var errorHtml = '<div class="error legy-marker ui warning message">' + msg + '</div>';
                dialog.html(errorHtml);
                return true;
            }
        );

        dialog.parent().attr('id', params.ref);

        dialog.parent().position({
            my: 'center',
            at: 'center',
            of: window
        });

        UI.Dialog.showOverlay();

        return dialog;
    },

    getName: function () {
        return UI.Dialog.params.name;
    },
    getRef: function () {
        return '#' + UI.Dialog.getName();
    },
    getInstance: function () {
        return $(UI.Dialog.getRef());
    },

    onLoad: function () {
        UI.Dialog.isOpen = true;

        var dialog = UI.Dialog.getInstance();

        if (is_function(UI.Dialog.params.onSetup)) {
            UI.Dialog.params.onSetup(dialog);
        }
        if (is_function(UI.Dialog.params.onLoad)) {
            UI.Dialog.params.onLoad(dialog);
        }
    },

    showOverlay: function () {
        var dlg = $('#' + UI.Dialog.params.ref);
        var overlayId = UI.Dialog.params.ref + '-overlay';
        if (dlg.length > 0 && $('#' + overlayId).length === 0) {
            UI.Dialog.params.overlay = $('<div id="' + overlayId + '" class="ui-widget-overlay ui-front" style="z-index: ' + (dlg.css('z-index') - 1) + ';"></div>');
            UI.Dialog.params.overlay.appendTo('body');
        }
    },

    removeOverlay: function () {
        if (UI.Dialog.params.overlay) {
            UI.Dialog.params.overlay.remove();
        }
    },

    close: function () {
        UI.Dialog.isWaiting = false;
        UI.Dialog.onClose();
    },

    onOpen: function () {
        if (is_function(UI.Dialog.params.onOpen)) {
            UI.Dialog.params.onOpen();
        }
    },

    onClose: function () {
        // call onclose callback after destroy!
        if (is_function(UI.Dialog.params.onClose)) {
            UI.Dialog.params.onClose();
        }

        // Safe delete for jQuery UI 1.8.5
        UI.Dialog.isClosing = true;
        UI.Dialog.removeOverlay();

        var dialog = UI.Dialog.getInstance();

        try {
            dialog.dialog('destroy');
        } catch (er) { /* empty */
        }
        try {
            dialog.empty().remove();
        } catch (er) { /* empty */
        }

        // pop params
        UI.Dialog.allParams.pop();
        if (UI.Dialog.allParams.length > 0) {
            UI.Dialog.params = UI.Dialog.allParams[UI.Dialog.allParams.length - 1];
        }

        UI.Dialog.isClosing = false;
        UI.Dialog.isOpen = false;
    },

    onResize: function () {
        if (is_function(UI.Dialog.params.onResize)) {
            if (UI.Dialog.resizeTimer) {
                clearTimeout(UI.Dialog.resizeTimer);
            }
            UI.Dialog.resizeTimer = setTimeout(function () {
                clearTimeout(UI.Dialog.resizeTimer);
                UI.Dialog.params.onResize();
            }, UI.Dialog.resizeTrigger);
        }
    },

    doSubmit: function (submitIcon, onSuccess, onError, refreshOnly) {
        if (UI.Dialog.isWaiting) {
            return;
        } else {
            UI.Dialog.isWaiting = true;
        }

        UI.Dialog.showLoader();

        var doSubmit = true;

        if (is_function(UI.Dialog.params.beforeSubmit)) {
            doSubmit = UI.Dialog.params.beforeSubmit();
        }

        if (!doSubmit) {
            UI.Dialog.isWaiting = false;
            UI.Dialog.showLoaded();
            return;
        }

        UI.Dialog.executeSubmit(onSuccess, onError, refreshOnly);
    },

    executeSubmit: function (onSuccess, onError, refreshOnly) {
        UI.Dialog.hideErrors();

        var dialog = UI.Dialog.getInstance();

        if (is_function(UI.Dialog.params.submit)) {
            UI.Dialog.params.submit(refreshOnly);
            UI.Dialog.showLoaded();
        } else {
            var form = $('form', dialog);
            if (form.attr('action')) {
                var url = form.attr('action');
                if (refreshOnly) {
                    url = url + '&refresh=1';
                }
                if (!UI.Dialog.doClose) {
                    url = url + '&apply=1';
                }
                window.Browser.send(
                    url,
                    form.serialize(),
                    function (json) {
                        UI.Dialog.showLoaded();
                        UI.Dialog.onSubmitted(json);
                        if (is_function(onSuccess)) {
                            onSuccess();
                        }
                    },
                    function (json) {
                        UI.Dialog.showLoaded();
                        UI.Dialog.isWaiting = false;

                        if (is_function(onError)) {
                            onError();
                        }

                        var dialog2 = UI.Dialog.getInstance();
                        if ($('.tabError', dialog2).length == 0) {
                            UI.Dialog.showError(json, $('.error', dialog2));
                        } else {
                            UI.Dialog.showError(json, $('.tabError', dialog2));
                        }

                        return true;
                    }
                );
            } else {
                if (is_function(UI.Dialog.params.afterSubmit)) {
                    UI.Dialog.params.afterSubmit();
                }

                if (UI.Dialog.doClose) {
                    UI.Dialog.close();
                }
                UI.Dialog.showLoaded();
            }
        }

        UI.Dialog.isWaiting = false;
    },

    showLoader: function () {
        $('.lp-dlg-buttons-loader').timedLoader(1);
    },

    showLoaded: function () {
        $('.lp-dlg-buttons-loader').timedLoader(false);
    },

    onSubmitted: function (json) {
        UI.Dialog.isWaiting = false;
        if (is_function(UI.Dialog.params.afterSubmit)) {
            UI.Dialog.params.afterSubmit(json);
        }
        if (UI.Dialog.doClose) {
            UI.Dialog.close();
        }
        return true;
    },

    onChangeLanguage: function (lang) {
        var applyAndReload = true;
        if (is_function(UI.Dialog.params.onChangeLanguage)) {
            applyAndReload = UI.Dialog.params.onChangeLanguage(lang);
        }

        // reload content with changed language on success
        var onSuccess = function () {
            // change view on source page to display page with new language
            if (is_function(UI.Dialog.params.onRefreshLanguage)) {
                UI.Dialog.params.onRefreshLanguage(lang);
            }

            var url = $('#dialog_reload_url').val();
            if (url) {
                url = url + '&edit_lang=' + lang;
                UI.GET(url, 0, function (json) {
                    $('#dialog_content_div').html(json.html);
                    $('#dialog_language').val(lang);

                    // resetup page
                    if (is_function(UI.Dialog.params.onLoad)) {
                        UI.Dialog.params.onLoad(UI.Dialog.getRef());
                    }
                });
            }
        };

        // revert language on error
        var onError = function () {
            //var prevLang = $('#dialog_language');
            //var langSelect = $('#dialog_languages');
            //if (lang!=prevLang) langSelect.val(prevLang);
        };

        // in Dialogs with Tab => reload Tab with language
        if (UI.Dialog.Tabs.params && UI.Dialog.Tabs.params.name) {
            var tabs = $(UI.Dialog.Tabs.params.name).tabs();

            if (tabs.length != 0) {
                if (!UI.Dialog.Tabs.onChangeLanguage(lang)) { // Fehler beim Speichern? Sprache zurücksetzen. Anonsten selbstständiger refresh der Tabs  {onError();
                }
            }
        } else {
            if (applyAndReload) {
                var dialog = UI.Dialog.getInstance();

                // simulate 'apply' click, with current language
                UI.Dialog.doClose = false;

                UI.Dialog.doSubmit($('.apply_image', dialog), onSuccess, onError, true);
            }
        }
    },

    showError: function (json, errorElement) {
        var errors;

        if (json.errors && json.errors.length !== 0) {
            errors = is_array(json.errors) ? json.errors.join('<br>') : json.errors;
        } else {
            errors = '';
        }

        if (errors.length === 0) return;

        errorElement.html(errors);
        if (errorElement.is(':visible')) {
            errorElement.transition('pulse');
        } else {
            errorElement.show();
        }
    },

    hideErrors: function () {
        var dialog = UI.Dialog.getInstance();
        var errorElement;
        if ($('.tabError', dialog).length == 0) {
            errorElement = $('.error', dialog);
        } else {
            errorElement = $('.tabError', dialog);
        }

        errorElement.hide();
    }

};
